import React from 'react';
import { useSelector } from 'react-redux';
import { isSelectedShopifyOrderRefunded } from '../../../extractFromState';
import DTSendConstructedMacroAndPartialRefundItemsNode from '../NodeGroups/DTCopyTextSendMacro/DTSendConstructedMacroAndPartialRefundItemsNode/DTSendConstructedMacroAndPartialRefundItemsNode';

const SendConstructedMacroAndPartialRefundItems = () => {
  const selectedShopifyOrderRefunded = useSelector(isSelectedShopifyOrderRefunded);

  return (
    <DTSendConstructedMacroAndPartialRefundItemsNode
      message={'The order has been partially refunded.'}
      showConfirmation={selectedShopifyOrderRefunded}
    />
  );
};

export default SendConstructedMacroAndPartialRefundItems;
